import "./styles/HeroSection.css";
import { Link } from "react-router-dom";

export const HeroSectionHome = () => {
  return (
    <div className="heroSectionHome">
      <div className="heroOverlay">
        <h1>Sercons &amp; Contractor</h1>
        <p>
          Descoperiți proiectele noastre de construcții civile, industriale și
          amenajări.
        </p>
        <Link to="/portfolio" className="heroProjectLink">
          Vezi portofoliul
        </Link>
      </div>
    </div>
  );
};

export const HeroSectionPortfolio = () => {
  return (
    <div className="heroSection heroSectionPortfolio">
      <div className="heroOverlay">
        <h1>Portofoliul nostru de construcții</h1>
        <p>
          Vă invităm să explorați colecția noastră de imagini cu șantierele de
          lucru. Pentru poze mai recente, urmăriți-ne pe Facebook.
        </p>
      </div>
    </div>
  );
};

export const HeroSectionAbout = () => {
  return (
    <div className="heroSection heroSectionAbout">
      <div className="heroOverlay">
        <h1>Despre noi</h1>
        <p>
          Suntem o echipă de profesioniști pasionați de construcții și design.
          Vă invităm să ne cunoașteți mai bine.
        </p>
      </div>
    </div>
  );
};
